import { useUser } from 'builder/hooks/useUser'
import { useI18n } from 'builder/hooks/useI18n'

import { TRANSLATION } from '../../../constants'
import { Service } from '../../../../types'

export type GetPromotionInfo = {
  badge?: string
  header: string
  subHeader: string
  promotion_button: string
  coach_button: string
  promotion_button_mobile: string
  actionText: string
}

type Step = {
  completed?: boolean
  score?: number
}

export type Steps = {
  get_promotion?: Step
  career_coaching?: Step
}

type GetPromotionConfig = {
  text: GetPromotionInfo
  status: 'initial' | 'completed' | 'progress'
  steps: Steps
}

export const useGetPromotionConfig = (service: Service): GetPromotionConfig => {
  const user = useUser()
  const { i18n } = useI18n()
  const progress = service.calculatedProgress?.percentageProgress || 0

  const getSteps = () => {
    const getPromotion = service.data?.steps?.find(step => step.step_name === 'page_seen')
    const bookCoach = service.data?.steps?.find(step => step.step_name === 'career_coaching')

    return {
      get_promotion: {
        completed: user?.uiStates?.promotionPlanSeen || getPromotion?.completed,
        score: getPromotion?.target_score,
      },
      career_coaching: {
        completed: bookCoach?.completed,
        score: bookCoach?.target_score,
      },
    }
  }

  const getStatus = () => {
    const steps = getSteps()
    if (!steps.get_promotion?.completed) return 'initial'
    if (progress >= 100) return 'completed'
    return 'progress'
  }

  const getText = () => {
    const status = getStatus()
    const key = `get_promotion.${status}`

    return i18n.t(`${TRANSLATION}.${key}`) as unknown as GetPromotionInfo
  }

  return {
    text: getText(),
    status: getStatus(),
    steps: getSteps(),
  }
}
